var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2568_10971",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2568_10971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14C7.16667 14 6.38611 13.8417 5.65833 13.525C4.93056 13.2083 4.29722 12.7806 3.75833 12.2417C3.21944 11.7028 2.79167 11.0694 2.475 10.3417C2.15833 9.61389 2 8.83333 2 8C2 7.16667 2.15833 6.38611 2.475 5.65833C2.79167 4.93056 3.21944 4.29722 3.75833 3.75833C4.29722 3.21944 4.93056 2.79167 5.65833 2.475C6.38611 2.15833 7.16667 2 8 2V3.33333C6.7 3.33333 5.59722 3.78611 4.69167 4.69167C3.78611 5.59722 3.33333 6.7 3.33333 8C3.33333 9.3 3.78611 10.4028 4.69167 11.3083C5.59722 12.2139 6.7 12.6667 8 12.6667V14ZM10.6667 11.3333L9.73333 10.3833L11.45 8.66667H6V7.33333H11.45L9.73333 5.6L10.6667 4.66667L14 8L10.6667 11.3333Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.86363790144743967044b1bf992b6041.svg";
export { ForwardRef as ReactComponent };